import {chainWalk, deepCopyObject} from "../../../util/Util";
import {ASL_ASSET_TYPE, ASSET_CONFIG_ATTRIBUTES} from "../../../util/Constants";

const ASL_CONFIG_ATTRIBUTES = ASSET_CONFIG_ATTRIBUTES[ASL_ASSET_TYPE];

// inductTestPackage is only written when the page sends it, so stations without the Induct Test Package
// config type never get the attribute.
export const updateConfigurationsInAslAssetObject = (asset, configurations, alias) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.alias = chainWalk(() => alias.toString(), "");
    updatedAsset.assetDetails.assetAttributes[ASL_CONFIG_ATTRIBUTES.DIVERT_CONFIG] =
        chainWalk(() => JSON.stringify(configurations.divertConfig), "[]")
    if (configurations.inductTestPackage !== undefined) {
        updatedAsset.assetDetails.assetAttributes[ASL_CONFIG_ATTRIBUTES.INDUCT_TEST_PACKAGE] =
            chainWalk(() => JSON.stringify(configurations.inductTestPackage), "[]")
    }
    return updatedAsset;
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asldevice/datamodel/AslAssetModelResource.js